import { render, staticRenderFns } from "./workShop.vue?vue&type=template&id=087fcace&"
import script from "./workShop.vue?vue&type=script&lang=js&"
export * from "./workShop.vue?vue&type=script&lang=js&"
import style0 from "./workShop.vue?vue&type=style&index=0&id=087fcace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports